import { useContext, useState, useEffect, createContext } from "react"
import { node, oneOfType, arrayOf } from "prop-types"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import Jolt from "@planningcenter/jolt-client"
import { useSession } from "source/hooks/useSession"
import { WebBootContext } from "source/publishing/WebBoot"

export const JoltContext = createContext()
const fetchAuthTokenFn = async () => {
  const response = await sessionApiClient.post("/global/v2/jolt_connect")
  return response.data.id
}

const fetchSubscribeTokenFn = async (channel, connection_id) => {
  const response = await sessionApiClient.post(
    `/notifications/v2/me/jolt_subscribe`,
    {
      data: {
        attributes: {
          channel,
          connection_id,
        },
      },
    },
  )
  return response.data.id
}

export const JoltProvider = ({ children }) => {
  const [jolt, setJolt] = useState()
  const [notificationsChannel, setNotificationsChannel] = useState()
  const { joltWebsocketUrl } = useContext(WebBootContext)
  const {
    data: { id: currentPersonId },
  } = useSession(false)

  // Establish jolt connection
  useEffect(() => {
    const nextJolt = joltWebsocketUrl
      ? new Jolt(joltWebsocketUrl, { fetchAuthTokenFn }, { logToConsole: true })
      : null

    setJolt(nextJolt)
    return () => nextJolt?.disconnect()
  }, [joltWebsocketUrl])

  // Subscribe to notifications channel
  useEffect(() => {
    let nextChannel = null
    const name = currentPersonId
      ? `church_center.notifications.people.${currentPersonId}`
      : null

    if (jolt && name) {
      nextChannel = jolt.subscribe(name, { fetchSubscribeTokenFn })
    }

    setNotificationsChannel(nextChannel)

    return () => {
      if (nextChannel) jolt.unsubscribe(name)
    }
  }, [jolt, currentPersonId])

  return (
    <JoltContext.Provider value={{ jolt, notificationsChannel }}>
      {children}
    </JoltContext.Provider>
  )
}

JoltProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]),
}
